import { render } from "./LearningMaterials.vue?vue&type=template&id=549819a4"
import script from "./LearningMaterials.vue?vue&type=script&lang=js"
export * from "./LearningMaterials.vue?vue&type=script&lang=js"

import "./LearningMaterials.vue?vue&type=style&index=0&id=549819a4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__